module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="social-bnt-frame">\r\n	<div id="fb-root"></div>\r\n	<div class="fb-like" data-layout="button_count" data-action="like" data-show-faces="false" data-share="false" style="margin-right:35px;"></div>\r\n</div>';
}
return __p;
};
